import { render } from "./MarketplaceModal.vue?vue&type=template&id=b61cf27c&scoped=true"
import script from "./MarketplaceModal.vue?vue&type=script&lang=js"
export * from "./MarketplaceModal.vue?vue&type=script&lang=js"

import "./MarketplaceModal.vue?vue&type=style&index=0&id=b61cf27c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61cf27c"]])

export default __exports__